export default __webpack_public_path__ + "static/media/chevron-right.a4f29fdf.svg";